export enum MyAgreementSignStatus {
  NOT_APPLICABLE = 'MY_AGREEMENT_COURTESY_VEHICLE_STATUS_NOT_APPLICABLE',
  READY_TO_SIGN_CLAIM = 'MY_AGREEMENT_SIGN_STATUS_READY_TO_SIGN_CLAIM',
  READY_TO_SIGN_CV = 'MY_AGREEMENT_SIGN_STATUS_READY_TO_SIGN_CV',
  READY_TO_SIGN_ALL = 'MY_AGREEMENT_SIGN_STATUS_READY_TO_SIGN_ALL',
  SIGNED = 'MY_AGREEMENT_SIGN_STATUS_SIGNED',
}
